export default function OptionsGrid({ title, options, value, onChange }) {
    return (
      <div>
        <h3 className="text-xl font-semibold mb-4 mt-4">{title}</h3>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {options.map(opt => (
            <button
              key={opt}
              onClick={() => onChange(value === opt ? '' : opt)}
              className={`px-5 py-4 rounded-lg text-sm font-medium transition ${
                value === opt
                  ? 'bg-indigo-600 text-white border-indigo-500'
                  : 'bg-gray-200 dark:bg-dark-card hover:bg-gray-300 dark:hover:bg-dark-hover'
              }`}
            >
              {opt.charAt(0).toUpperCase() + opt.slice(1)}
            </button>
          ))}
        </div>
      </div>
    );
  }
  